import { log } from 'console';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiRoutes } from 'consts';
import { apiErrorHandler } from 'services/apiErrorHandler';
import {
  showErrorNotification,
  showSuccessNotification,
} from 'utils/notification';
import { ThunkConfig } from 'app/providers/StoreProvider';
import { UpdateStockItemI } from '../../lib/types';

export const updateStockItem = createAsyncThunk<
  UpdateStockItemI | undefined,
  UpdateStockItemI,
  ThunkConfig<string>
>('stock/updateStockItem', async (updateStockItem, thunkApi) => {
  const {
    extra: { api },
  } = thunkApi;
  try {
    const data = await api.put(ApiRoutes.Stock, updateStockItem);

    if (!data) {
      showErrorNotification(['Не удалось обновить']);

      return;
    }

    showSuccessNotification(['Элемент успешно обновлен']);

    return updateStockItem;
  } catch (error) {
    console.log(error, 'update rror');

    const { message } = apiErrorHandler(error);
    showErrorNotification([message]);
    // Важно возвращать явно undefined, если функция должна завершиться после ошибки
    return undefined;
  }
});
